<template>
  <div>
  <div v-if="$store.state.data.layout && $store.state.data.about">
     <!-- <style v-if="$store.state.data.layout">
      html,body,div,p,a,span,h1,h2,h3,h4,h5,table,tr,td,tbody{
        color:{{$store.state.data.layout.font_color}};
      }
    </style> -->
     <div
     v-if="$store.state.data.layout && $store.state.data.about"
      style="height:100vh;position:absolute;z-index:16;width:100vw;" class="d-flex justify-content-center align-items-center  bg-dark">
      <div id="particlesjsmain"  style="position:fixed;z-index:16;width:100%;height:100vh;"></div>
            <div  style="position:fixed;z-index:17;width:100%;">
                <div class="row justify-content-center p-2 sm:p-0">
                  <div class=" col-sm-3 mb-4 text-center">
                   
                  </div>
                  <div class="col-sm-7 mb-4 text-center" style=" font-family:  'Merienda', cursive;">
                    <div class="d-none d-sm-block">
                      <p class="text-center text-3xl text-orange-400 mb-3">Portofolio !</p>
                      <button type="button" class="btn btn-sm btn-warning font-semibold ml-2" @click="$router.push('/a-2/')"><span class="typcn typcn-user"></span> About</button>
                      <button type="button" class="btn btn-sm btn-warning font-semibold ml-2" @click="$router.push('/a-2/portofolio')"><span class="typcn typcn-typcn-news"></span> Portofolio</button>
                      <button type="button" class="btn btn-sm btn-warning font-semibold ml-2" @click="$router.push('/a-2/contact')"><span class="typcn typcn-document-text"></span> Contact</button>
                      <button type="button" class="btn btn-sm btn-warning font-semibold ml-2" @click="$router.push('/a-2/project')"><span class="typcn typcn-anchor"></span> My Project</button>
                      <button type="button" class="btn btn-sm btn-warning font-semibold ml-2" @click="$router.push('/a-2/sertifikat')"><span class="typcn typcn-bookmark"></span> My Certificate</button>
                      <!-- <button type="button" class="btn btn-sm btn-warning font-semibold ml-2" @click="$router.push('/a-2/coffe')"><span class="typcn typcn-coffee"></span> Buy Me a Coffe</button> -->
                    </div>
                  </div>
                  <div class="col-1"></div>
                  <div class="col-md-3">
                    <div class="d-block d-sm-none">
                      <div style='overflow-x:scroll;overflow-y:hidden;width:100vw;height:80px;white-space: nowrap;'>
                        <button type="button" class="btn btn-sm btn-dark border-2 border-white text-sm p-4" 
                        @click="$router.push(item.link)"
                        v-for="(item, index) in menus" :key="index+''">
                          <span class="typcn " :class="`typcn-${item.icon}`"></span> {{item.nama}}
                        </button>
                      </div>
                    </div>
                    <div class="d-none d-sm-block text-center">
                      <img :src="$store.state.data.about.gambar" alt="" class="img-fluid rounded-lg shadow" v-viewer style="display:block;margin:auto;">
                       <p class="text-white text-center font-semibold">{{$store.state.data.about.nama}}</p>
                    <br>
                    <a :href="$store.state.data.about.github">
                      <button
                        type="button"
                        class="btn btn-sm btn-style9"
                                :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                        style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
                      >
                        <img src="https://upload.egov.balangankab.go.id/svg/social-github-circular.svg" 
                          class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                      </button>
                    </a>
                    <a :href="$store.state.data.about.linkedin">
                      <button
                        type="button"
                        class="btn btn-sm btn-style9"
                                :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                        style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
                      >
                      <img src="https://upload.egov.balangankab.go.id/svg/social-linkedin-circular.svg" 
                          class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                      </button>
                    </a>
                    <a :href="$store.state.data.about.instagram">
                      <button
                        type="button"
                        class="btn btn-sm btn-style9"
                                :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                        style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
                      >
                      <img src="https://upload.egov.balangankab.go.id/svg/social-instagram.svg" 
                          class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                      </button>
                    </a>
                    <a :href="$store.state.data.about.facebook">
                      <button
                        type="button"
                        class="btn btn-sm btn-style9"
                                :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                        style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
                      >
                      <img src="https://upload.egov.balangankab.go.id/svg/social-facebook.svg" 
                          class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                      </button>
                    </a>
                    </div>
                  </div>
                  <div class="col-md-8" style="height:80vh;overflow:scroll;">
                    <router-view/>
                  </div>
                </div>
            </div>
        </div>
  </div>
  </div>
</template>
<script>
import autophp from '@/plugins/autophp';
let sdb = new autophp();
let urlnya="https://gis.officialapp.my.id";
import Left1 from '@/components/a-1/Left1.vue'
export default{
  components:{
    Left1
  },
    layout:'a-2',
    data(){
        return{
            datanya:[],
            ready:false,
            menus:[
              {
                nama:'About',
                link:'/a-2/',
                icon:'user'
              },
              {
                nama:'Portofolio',
                link:'/a-2/portofolio',
                icon:'news'
              },
              {
                nama:'Contact',
                link:'/a-2/contact',
                icon:'document-text'
              },
              {
                nama:'Project',
                link:'/a-2/project',
                icon:'anchor'
              },
              {
                nama:'Sertifikat',
                link:'/a-2/sertifikat',
                icon:'bookmark'
              },
              // {
              //   nama:'Buy Me Coffe!',
              //   link:'/a-2/coffe',
              //   icon:'coffe'
              // },
            ]
        }
    },
    mounted() {
      let that=this;
      if(this.$store.state.data.layout){
        let particle=this.$store.state[this.$store.state.data.layout.particle];
        particle.particles.color.value=this.$store.state.data.layout.particle_point
        particle.particles.shape.stroke.color=this.$store.state.data.layout.particle_point
        particle.particles.line_linked.color=this.$store.state.data.layout.particle_line
        window.particlesJS("particlesjsmain", particle)
var style = document.createElement('style');
style.innerHTML=` html,body,div,p,a,span,h1,h2,h3,h4,h5,table,tr,td,tbody{
color:${this.$store.state.data.layout.font_color};
}`;
document.appendChild(style);
        that.ready=true;
      }else{
         this.$router.push('/')
        this.$store.state.data.fullPath=this.$route.fullPath
        setTimeout(() => {
          this.$router.push(`${this.$store.state.data.fullPath}`)
        }, 2000);
      }
    },
    methods: {
    },
}
</script>
<style>

</style>
